// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.left-nav {
  position: sticky !important;
  top: 20;
  width: 80px;
}

.bg-nav {
  background-color: #414b4f;
}

.left-nav__nav .btn-left-nav {
  background-color: #414b4f;
  color: #f2f2f2;
  display: flex;
  white-space: nowrap;
  width: 100%;
  font-size: 10px;
  flex-direction: column;
  align-items: center;
  text-align: center;
  line-height: 1.2;
}
.left-nav__nav .btn-left-nav:hover {
  color: #00C9B7;
}
.left-nav__nav .btn-left-nav .fa-lg {
  margin-right: 0;
}
@media (max-height: 650px) {
  .left-nav__nav .btn-left-nav .fa-lg {
    font-size: 15px !important;
  }
}
.left-nav__nav .header-logo {
  display: flex;
  justify-content: center;
  height: 60px;
  text-decoration: none;
  width: 100%;
}
.left-nav__nav .header-logo img {
  height: 40px;
  margin: 10px;
}
.left-nav__nav .header-logo h2 {
  color: #f2f2f2;
  margin: 15px 5px;
}
.left-nav__nav .nav-link {
  color: #f2f2f2;
  display: flex;
  font-family: "Open Sans Semibold", sans-serif;
  font-size: 14px;
  white-space: nowrap;
  width: 100%;
  font-size: 10px;
  flex-direction: column;
  align-items: center;
  text-align: center;
  line-height: 1.2;
  margin-bottom: 3px;
}
.left-nav__nav .nav-link .svg-inline--fa {
  margin-bottom: 4px;
}
@media (max-height: 650px) {
  .left-nav__nav .nav-link .svg-inline--fa {
    margin-bottom: 0;
  }
}
@media (max-height: 650px) {
  .left-nav__nav .nav-link {
    margin-bottom: 0;
  }
}
@media (max-height: 650px) {
  .left-nav__nav .nav-link svg {
    font-size: 15px !important;
  }
}
.left-nav__nav .nav-link .fa-lg {
  background-color: #414b4f;
  color: #f2f2f2;
  font-size: 24px;
}
.left-nav__nav .nav-link:hover {
  color: #00C9B7;
}
.left-nav__nav .nav-link:focus {
  color: #00C9B7;
}
.left-nav__nav .nav-link .selected {
  color: #00C9B7;
}
.left-nav__nav .selected {
  border-left: #00C9B7 5px solid;
  color: #00C9B7;
  padding-left: 15px;
}
.left-nav__nav .selected .fa-lg {
  color: #00C9B7;
}
.left-nav__nav .selected .hover {
  color: #00C9B7;
}

.btn.btn-left-nav.btn.btn-secondary:hover {
  background-color: #414b4f;
}
.btn.btn-left-nav.btn.btn-secondary:selected {
  background-color: #414b4f;
}

.svg-inline--fa.fa-bars.fa-lg:hover {
  background-color: #414b4f;
  color: #00C9B7;
}
.svg-inline--fa.fa-bars.fa-lg:selected {
  background-color: #414b4f;
}

.btn.btn-left-nav.btn.btn-secondary:hover {
  color: #00C9B7;
}

.left-nav__collapse.left-nav__collapse__closed.collapse .nav-link:hover {
  background-color: #414b4f;
  color: #00C9B7;
}
.left-nav__collapse.left-nav__collapse__closed.collapse .nav-link .fa-lg.font-awesome-icon {
  color: #f2f2f2;
}
.left-nav__collapse.left-nav__collapse__closed.collapse .nav-link .fa-lg.font-awesome-icon:hover {
  background-color: #414b4f;
  color: #00C9B7;
}
.left-nav__collapse.left-nav__collapse__closed.collapse .svg-inline--fa.fa-right-from-bracket.fa-lg.font-awesome-icon {
  color: #f2f2f2;
}
.left-nav__collapse.left-nav__collapse__closed.collapse .svg-inline--fa.fa-right-from-bracket.fa-lg.font-awesome-icon:hover {
  background-color: #414b4f;
  color: #00C9B7;
}

.nav-link.selected {
  color: #00C9B7;
}

.svg-inline--fa.fa-bars.fa-lg.font-awesome-icon {
  color: #f2f2f2;
}

.svg-inline--fa.fa-right-from-bracket.fa-lg.font-awesome-icon {
  color: #f2f2f2;
}

.left-nav-fixed {
  bottom: 0;
  left: 0;
  position: fixed;
  top: 0;
  width: 200px;
}

.nav-logout-modal .logout-header {
  border-bottom: none;
}
.nav-logout-modal .logout-header .logout-header-txt {
  color: #414b4f;
  flex-grow: 0;
  font-family: "Open Sans";
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  font-weight: bold;
  height: 30px;
  letter-spacing: normal;
  line-height: 1.5;
  text-align: center;
  width: 206px;
}
.nav-logout-modal .btn.btn-primary {
  border-radius: 4px;
  color: #ffffff;
  font-family: "Open Sans";
  font-size: 16px;
  font-stretch: normal;
  font-style: normal;
  font-weight: 600;
  letter-spacing: normal;
  line-height: 1.5;
  margin: 0 10px;
  text-align: center;
}
.nav-logout-modal .btn.btn-secondary {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: none;
  color: #414b4f;
  flex-grow: 0;
  font-family: "Open Sans";
  font-size: 16px;
  font-stretch: normal;
  font-style: normal;
  font-weight: 600;
  letter-spacing: normal;
  line-height: 1.5;
  margin: 0 10px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/common/LeftNav.scss"],"names":[],"mappings":"AAQA;EACE,2BAAA;EACA,OAAA;EACA,WAAA;AAPF;;AAUA;EACE,yBAAA;AAPF;;AAWE;EACE,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AARJ;AAUI;EACE,cA1BiB;AAkBvB;AAWI;EACE,eAAA;AATN;AAWM;EAHF;IAII,0BAAA;EARN;AACF;AAYE;EACE,aAAA;EACA,uBAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;AAVJ;AAYI;EACE,YAAA;EACA,YAAA;AAVN;AAaI;EACE,cAAA;EACA,gBAAA;AAXN;AAeE;EACE,cAAA;EACA,aAAA;EACA,6CAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAbJ;AAeI;EACE,kBAAA;AAbN;AAeM;EAHF;IAII,gBAAA;EAZN;AACF;AAeI;EAtBF;IAuBI,gBAAA;EAZJ;AACF;AAeM;EADF;IAEI,0BAAA;EAZN;AACF;AAeI;EACE,yBAAA;EACA,cAAA;EACA,eAAA;AAbN;AAgBI;EACE,cA/FiB;AAiFvB;AAiBI;EACE,cAnGiB;AAoFvB;AAkBI;EACE,cAvGiB;AAuFvB;AAoBE;EACE,8BAAA;EACA,cA7GmB;EA8GnB,kBAAA;AAlBJ;AAmBI;EACE,cAhHiB;AA+FvB;AAoBI;EACE,cApHiB;AAkGvB;;AAwBE;EACE,yBAAA;AArBJ;AAwBE;EACE,yBAAA;AAtBJ;;AA2BE;EACE,yBAAA;EACA,cAtImB;AA8GvB;AA2BE;EACE,yBAAA;AAzBJ;;AA8BE;EACE,cAhJmB;AAqHvB;;AAiCI;EACE,yBAAA;EACA,cAxJiB;AA0HvB;AAiCI;EACE,cAAA;AA/BN;AAgCM;EACE,yBAAA;EACA,cA/Je;AAiIvB;AAmCE;EACE,cAAA;AAjCJ;AAkCI;EACE,yBAAA;EACA,cAxKiB;AAwIvB;;AAqCA;EACE,cA9KqB;AA4IvB;;AAqCA;EACE,cAAA;AAlCF;;AAqCA;EACE,cAAA;AAlCF;;AAqCA;EACE,SAAA;EACA,OAAA;EACA,eAAA;EACA,MAAA;EACA,YAAA;AAlCF;;AAsCE;EACE,mBAAA;AAnCJ;AAoCI;EACE,cAAA;EACA,YAAA;EACA,wBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AAlCN;AAsCE;EACE,kBAAA;EACA,cAAA;EACA,wBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AApCJ;AAuCE;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,wBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AArCJ","sourcesContent":["@import '../../styles/colors';\n\n$sidebar-background-color: #313443;\n$active-sidebar-link-color: #22252e;\n$hover-sidebar-link-color: $active-sidebar-link-color;\n$tooltip-background-color: $sidebar-background-color;\n$sidebar-active-color: #00C9B7;\n\n.left-nav {\n  position: sticky !important;\n  top: 20;\n  width: 80px;\n}\n\n.bg-nav {\n  background-color: #414b4f;\n}\n\n.left-nav__nav {\n  .btn-left-nav {\n    background-color: #414b4f;\n    color: #f2f2f2;\n    display: flex;\n    white-space: nowrap;\n    width: 100%;\n    font-size: 10px;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    line-height: 1.2;\n\n    &:hover {\n      color: $sidebar-active-color;\n    }\n\n    .fa-lg {\n      margin-right: 0;\n\n      @media (max-height: 650px) {\n        font-size: 15px !important;\n      }\n    }\n  }\n\n  .header-logo {\n    display: flex;\n    justify-content: center;\n    height: 60px;\n    text-decoration: none;\n    width: 100%;\n\n    img {\n      height: 40px;\n      margin: 10px;\n    }\n\n    h2 {\n      color: #f2f2f2;\n      margin: 15px 5px;\n    }\n  }\n\n  .nav-link {\n    color: #f2f2f2;\n    display: flex;\n    font-family: 'Open Sans Semibold', sans-serif;\n    font-size: 14px;\n    white-space: nowrap;\n    width: 100%;\n    font-size: 10px;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    line-height: 1.2;\n    margin-bottom: 3px;\n\n    .svg-inline--fa {\n      margin-bottom: 4px;\n\n      @media (max-height: 650px) {\n        margin-bottom: 0;\n      }\n    }\n\n    @media (max-height: 650px) {\n      margin-bottom: 0;\n    }\n\n    svg {\n      @media (max-height: 650px) {\n        font-size: 15px !important;\n      }\n    }\n\n    .fa-lg {\n      background-color: #414b4f;\n      color: #f2f2f2;\n      font-size: 24px;\n    }\n\n    &:hover {\n      color: $sidebar-active-color;\n    }\n\n    &:focus {\n      color: $sidebar-active-color;\n    }\n\n    .selected {\n      color: $sidebar-active-color;\n    }\n  }\n\n  .selected {\n    border-left: $sidebar-active-color 5px solid;\n    color: $sidebar-active-color;\n    padding-left: 15px;\n    .fa-lg {\n      color: $sidebar-active-color;\n    }\n\n    .hover {\n      color: $sidebar-active-color;\n    }\n  }\n}\n\n.btn.btn-left-nav.btn.btn-secondary {\n  &:hover {\n    background-color: #414b4f;\n  }\n\n  &:selected {\n    background-color: #414b4f;\n  }\n}\n\n.svg-inline--fa.fa-bars.fa-lg {\n  &:hover {\n    background-color: #414b4f;\n    color: $sidebar-active-color;\n  }\n\n  &:selected {\n    background-color: #414b4f;\n  }\n}\n\n.btn.btn-left-nav.btn.btn-secondary {\n  &:hover {\n    color: $sidebar-active-color;\n  }\n}\n\n.left-nav__collapse.left-nav__collapse__closed.collapse {\n  .nav-link {\n    &:hover {\n      background-color: #414b4f;\n      color: $sidebar-active-color;\n    }\n\n    .fa-lg.font-awesome-icon {\n      color: #f2f2f2;\n      &:hover {\n        background-color: #414b4f;\n        color: $sidebar-active-color;\n      }\n    }\n  }\n\n  .svg-inline--fa.fa-right-from-bracket.fa-lg.font-awesome-icon {\n    color: #f2f2f2;\n    &:hover {\n      background-color: #414b4f;\n      color: $sidebar-active-color;\n    }\n  }\n}\n\n.nav-link.selected {\n  color: $sidebar-active-color;\n}\n\n.svg-inline--fa.fa-bars.fa-lg.font-awesome-icon {\n  color: #f2f2f2;\n}\n\n.svg-inline--fa.fa-right-from-bracket.fa-lg.font-awesome-icon {\n  color: #f2f2f2;\n}\n\n.left-nav-fixed {\n  bottom: 0;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 200px;\n}\n\n.nav-logout-modal {\n  .logout-header {\n    border-bottom: none;\n    .logout-header-txt {\n      color: #414b4f;\n      flex-grow: 0;\n      font-family: 'Open Sans';\n      font-size: 20px;\n      font-stretch: normal;\n      font-style: normal;\n      font-weight: bold;\n      height: 30px;\n      letter-spacing: normal;\n      line-height: 1.5;\n      text-align: center;\n      width: 206px;\n    }\n  }\n \n  .btn.btn-primary {\n    border-radius: 4px;\n    color: #ffffff;\n    font-family: 'Open Sans';\n    font-size: 16px;\n    font-stretch: normal;\n    font-style: normal;\n    font-weight: 600;\n    letter-spacing: normal;\n    line-height: 1.5;\n    margin: 0 10px;\n    text-align: center;\n  }\n\n  .btn.btn-secondary {\n    background-color: #fff;\n    border-radius: 4px;\n    box-shadow: none;\n    color: #414b4f;\n    flex-grow: 0;\n    font-family: 'Open Sans';\n    font-size: 16px;\n    font-stretch: normal;\n    font-style: normal;\n    font-weight: 600;\n    letter-spacing: normal;\n    line-height: 1.5;\n    margin: 0 10px;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
